{
  "categories": [
    {
      "id": "vorspeisen",
      "name": "Vorspeisen & Antipasti",
      "displayOrder": 1,
      "items": [
        {
          "id": "antipasti-teller",
          "name": "Antipasti-Teller",
          "description": "Eine mediterrane Auswahl aus gegrilltem Gemüse, Bruschetta, aromatischen Tomaten und ofenfrischen Pizzabrötchen – vielseitig und voller Geschmack"
        },
        {
          "id": "bruschetta-classica",
          "name": "Bruschetta Classica",
          "description": "Ofenfrisch geröstete Brotscheiben mit frischen Tomaten, Rucola, Parmesan und bestem Olivenöl – leicht, aromatisch und ein wunderbarer Einstieg"
        },
        {
          "id": "gamberoni-al-aglio",
          "name": "Gamberoni al Aglio",
          "description": "Gebratene Garnelen in aromatischem Knoblauchöl mit feiner Chili auf frischem Rucola – leicht, würzig und mit mediterraner Eleganz"
        },
        {
          "id": "feta-al-forno",
          "name": "Feta al Forno",
          "description": "Warmer Feta aus dem Ofen, verfeinert mit Olivenöl, Knoblauch und Rosmarin – würzig, cremig und herrlich aromatisch"
        }
      ]
    },
    {
      "id": "salate",
      "name": "Salate",
      "displayOrder": 2,
      "items": [
        {
          "id": "insalata-della-casa",
          "name": "Insalata della Casa",
          "description": "Knackige Blattsalate, frische Gurke, Cherrytomaten, Paprika und rote Zwiebeln – frisch, klar und angenehm mediterran"
        },
        {
          "id": "pollo-caesar",
          "name": "Pollo Caesar Style",
          "description": "Zarte Hähnchenbrust, knusprige Croutons, Parmesan und cremiges Caesar-Dressing – würzig, vertraut und mit eigenem Charakter"
        },
        {
          "id": "gamberoni-fresco",
          "name": "Gamberoni Fresco",
          "description": "Gegrillte Garnelen, Lauchzwiebeln und frische Tomaten – ein Salat wie ein kleiner Kurzurlaub am Meer"
        },
        {
          "id": "salsiccia-rustica",
          "name": "Salsiccia Rustica",
          "description": "Würzige italienische Salsiccia, Champignons, Peperoni und eine feine Knoblauchnote – kräftig, rustikal und alles andere als gewöhnlich"
        }
      ]
    },
    {
      "id": "pasta",
      "name": "Pasta",
      "displayOrder": 3,
      "items": [
        {
          "id": "spaghetti-carbonara",
          "name": "Spaghetti Carbonara",
          "description": "Ein cremiger Pasta-Klassiker mit Speck, Sahne, Ei, Parmesan und schwarzem Pfeffer – italienisch inspiriert und herrlich cremig"
        },
        {
          "id": "lasagne",
          "name": "Lasagne al Forno",
          "description": "Schicht für Schicht ein echtes Wohlfühlgericht – würzige Fleischsauce, feine Pasta und goldbraun überbackener Käse frisch aus dem Ofen"
        },
        {
          "id": "spaghetti-aglio-olio",
          "name": "Spaghetti Aglio e Olio",
          "description": "Der mediterrane Klassiker: Olivenöl, Knoblauch, Peperoncino und frische Petersilie – aromatisch, puristisch und voller Duft"
        },
        {
          "id": "gnocchi-spinaci-gorgonzola",
          "name": "Gnocchi Spinaci Gorgonzola",
          "description": "Zarte Gnocchi mit Blattspinat, aromatischem Knoblauch und cremigem Gorgonzola – vollmundig mit viel Tiefe"
        }
      ]
    },
    {
      "id": "pizza",
      "name": "Pizza",
      "displayOrder": 4,
      "items": [
        {
          "id": "pizza-margherita",
          "name": "Margherita",
          "description": "Ein italienischer Klassiker mit fruchtiger Tomatensauce, aromatischen Cherrytomaten und geriebenem Mozzarella – schlicht, ausgewogen und immer wieder gut"
        },
        {
          "id": "pizza-crudo",
          "name": "Crudo",
          "description": "Italienischer Landschinken, würziger Parmesan, frischer Rucola und saftige Cherrytomaten – herzhaft und mit mediterranem Charakter"
        },
        {
          "id": "pizza-gamberoni",
          "name": "Gamberoni",
          "description": "Saftige Garnelen, aromatische Cherrytomaten, Rucola und herzhafte Oliven – frisch, elegant und mit mediterraner Leichtigkeit"
        },
        {
          "id": "pizza-quattro-formaggi",
          "name": "Quattro Formaggi",
          "description": "Mozzarella, Fetakäse, Gorgonzola und Parmesan – würzig, vollmundig und wunderbar harmonisch"
        }
      ]
    }
  ]
}
